module.exports = __webpack_public_path__ + "img/nodata.4fa8d8d1.png";